<template>
  <div>
    <h1>Home Page</h1>
    <p>Welcome to the home page!</p>
    <router-link to="/home/section1">Go to Section 1</router-link>
    <router-link to="/home/section2">Go to Section 2</router-link>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>